import * as Icons from "lucide-react";

// Render a lucide-react icon by string name.
export default function Icon({ name, className = "h-6 w-6", ...props }) {
  const C = Icons[name] || Icons.Circle;
  return <C className={className} {...props} />;
}
